module.exports = __webpack_public_path__ + "img/contact_a01.4858b2ef.png";